import { Roles } from '@/router/roles';

export const assignorRoutes = [
	{
		path: 'assignor',
		name: 'Assignors Dashboard',
		meta: Roles.ASSIGNOR,
		component: () => import('@/views/RefereeAssignor/Dashboard/AssignorDashboard.vue')
	},
	{
		path: 'upload-settings',
		name: 'Upload Settings',
		meta: Roles.ASSIGNOR,
		component: () => import('@/views/UploadSettings/uploadSettings.vue')
	},
	{
		path: 'fees',
		name: 'Fees',
		meta: Roles.ASSIGNOR,
		component: () => import('@/views/MatchFees/Fees.vue')
	},
	{
		path: 'assignor-reports',
		name: 'Assignor Match Reports',
		meta: Roles.ASSIGNOR,
		component: () => import('@/views/MatchReports/ReportsPage.vue'),
		props: {
			mode: 'assignor'
		}
	},
	{
		path: 'assignor-financial',
		name: 'Assignors Financial Records',
		meta: Roles.ASSIGNOR,
		component: () => import('@/finance/views/MyPay.vue'),
		props: { role: 'assignor' }
	},
	{
		path: '/app/assigning/fields',
		name: 'Field Assigning View',
		component: () => import('@/views/AssigningDatatable/components/FieldAssigningTab.vue')
	}
];
